import { mainAPI } from "../../api";

import { ApiErrorResponse } from "../../types/api/error";
import {
  RegionsListRequest,
  RegionsListResponse,
} from "../../types/api/regions";

const path = `/geo/${process.env.REACT_APP_API_VERSION}/regions`;

export function fetchRegionsList(params: RegionsListRequest) {
  return mainAPI.get<RegionsListResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(new Error(apiError?.detail || "Произошла ошибка"));
    }
  );
}
